import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Blocks } from "../index"

const BlockComp = ({ children, classes, block, event }) => {
  const Block = Blocks[block.name]
  return Block ? <Block data={block} event={event} /> : null
}

export default withStyles(styles, { withTheme: true })(BlockComp)



// WEBPACK FOOTER //
// ./src/components/Template/Block/index.jsx